import React, { PureComponent } from 'react';

class MenuAcordeon extends PureComponent {
    constructor(props) {
        super(props);

        this.state = { isActive: (props.cuenta.Id == props.currentCuentaId) }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isActive: (nextProps.cuenta.Id == nextProps.currentCuentaId)
        });
    }

    componentDidMount() {
        if (this.state.isActive) {
            const node = document.getElementById("cuerpo-menu-" + this.props.cuenta.Id);

            node.style.maxHeight = node.scrollHeight + "px";
        }
    }

    render() {
        const { cuenta, currentCuentaId } = this.props;
        const claseCabecera = ("cabecera" + ((this.state.isActive) ? " activo" : ""));

        return (
            <div className="menu-acordeon">
                <button type="button" className={claseCabecera} data-descripcion={cuenta.Descripcion} onClick={(event) => {
                    const { descripcion } = event.target.dataset;
                    const cuerpo = event.target.nextElementSibling;

                    if (cuerpo.style.maxHeight) {
                        cuerpo.style.maxHeight = null;
                        event.target.innerText = "►  " + descripcion;
                    } else {
                        cuerpo.style.maxHeight = cuerpo.scrollHeight + "px";
                        event.target.innerText = "▼  " + descripcion;
                    }
                }}>{"►  " + cuenta.Descripcion}</button>
                <div id={"cuerpo-menu-" + cuenta.Id} className="cuerpo contenedor">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default MenuAcordeon;